import { TelemetryBarGroup, TelemetryBarGroupParams } from '@shared/interfaces/telemetry';
import { ChartOptions } from 'chart.js';
import { getSeriesColor } from '../../../../utils/color/color';

export const createGroupedBar = (graph: TelemetryBarGroup) => {
  return {
    type: 'bar' as const,
    title: graph.title,
    options: createOptions(graph.params),
    data: buildChartData(graph.data),
    height: 400,
    plugins: [],
  };
};

const buildChartData = (data: TelemetryBarGroup['data']) => {
  const labels = [...new Set(data.map((el) => el.size_group_str))];
  const types = [...new Set(data.map((el) => el.type))];

  const datasets = types.map((type, typeIdx) => ({
    label: type,
    data: labels.map((label) => data.find((el) => el.type === type && el.size_group_str === label)?.count ?? 0),
    backgroundColor: getSeriesColor(typeIdx),
  }));

  return { datasets, labels };
};

const createOptions = (options: TelemetryBarGroupParams): ChartOptions<'bar'> => {
  return {
    maintainAspectRatio: false,
    responsive: true,
    animation: false,
    scales: {
      x: {
        title: { text: options.labels.size_group_str, display: true, font: { weight: 'bold' } },
      },
      y: {
        title: { text: options.labels.count, display: true, font: { weight: 'bold' } },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'right',
      },
    },
  };
};
